import ApiClient from '../apiClient';

interface GetAccountsParams {
  page?: number;
  page_size?: number;
  of_user_name?: string;
  name?: string;
  id?: string;
  of_id?: number;
  owner_type?: 'creator' | 'agency';
  search?: string;
  status?: 'verified' | 'wait_media' | 'moderation' | 'active' | 'deactivated';
}

const partnerAccService = {
  getAccounts: (params?: GetAccountsParams) => {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.page_size) queryParams.append('page_size', params.page_size.toString());
    if (params?.of_user_name) queryParams.append('of_user_name', params.of_user_name);
    if (params?.name) queryParams.append('name', params.name);
    if (params?.id) queryParams.append('id', params.id);
    if (params?.of_id) queryParams.append('of_id', params.of_id.toString());
    if (params?.owner_type) queryParams.append('owner_type', params.owner_type);
    if (params?.search) queryParams.append('search', params.search);
    if (params?.status) queryParams.append('status', params.status);

    const queryString = queryParams.toString();
    const url = queryString ? `/partners/models?${queryString}` : '/partners/models';
    return ApiClient.get(url);
  },
  createAccount: (data: any) => ApiClient.post('/models', data),

  createConfirmCode: (modelName: any) =>
    ApiClient.post(`/partners/models/confirm_code?of_model_name=${modelName}`, {}),
  checkConfirmCode: (modelName: any) =>
    ApiClient.get(`/partners/models/confirm_code?of_model_name=${modelName}`),
  setCredentials: (modelId: any, credentials: any) =>
    ApiClient.post(`/models/${modelId}/credentials`, credentials),
  workMedia: (modelId: any, mediaData: any) =>
    ApiClient.post(`/models/${modelId}/media/work`, mediaData),
  publicMedia: (modelId: any, mediaData: any) =>
    ApiClient.post(`/models/${modelId}/media/public`, mediaData),
  deletePublicMedia: (modelId: any, mediaId: any) =>
    ApiClient.delete(`/models/${modelId}/media/public/${mediaId}`),
  depositGuarantee: (modelId: any, amount: any) =>
    ApiClient.post(`/models/${modelId}/guarantee/deposit`, { amount }),
  requestGuaranteeRefund: (modelId: any) => ApiClient.post(`/models/${modelId}/guarantee/refund`, {}),
  getInvoices: (modelId: any, params?: any) =>
    ApiClient.get(`/models/${modelId}/invoices`, { params }),
  getInvoiceById: (modelId: any, invoiceId: any) =>
    ApiClient.get(`/models/${modelId}/invoices/${invoiceId}`),
  getCampaigns: (modelId: any, params?: any) =>
    ApiClient.get(`/models/${modelId}/campaigns`, { params }),
  getCampaignById: (modelId: any, campaignId: any) =>
    ApiClient.get(`/models/${modelId}/campaigns/${campaignId}`),
  getModelById: (modelId: any) => ApiClient.get(`/models/${modelId}`),
};

export default partnerAccService;
